'use strict';

exports.__esModule = true;
var presetsTypes = exports.presetsTypes = {
  DEFAULT: 'DEFAULT',
  PUBLIC: 'PUBLIC',
  MOBILE: 'MOBILE'
};